/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './ServiceCatalogServiceRpc';
import * as Queries from './ServiceCatalogServiceRpc.dfc.new';
import type { AdditionalContextArgs } from './ServiceCatalogServiceRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetServicesQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetServicesResponseType>,
    References.GetServicesRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getServices', References.GetServicesResponseType>
        : References.GetServicesResponseType)
    | undefined;
};

export function useGetServicesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetServicesResponseType>,
    References.GetServicesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetServicesQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_SERVICES_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getServices: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetServicesQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetServicesQueryReturn<T>;
}

type UseGetServicesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetServicesResponseType>,
    References.GetServicesRequestType,
    T extends true
      ? Record<'getServices', References.GetServicesResponseType>
      : References.GetServicesResponseType
  >;

export function useGetServicesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetServicesResponseType>,
    References.GetServicesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetServicesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SERVICES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getServices: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetServicesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetServicesLazyQueryReturn<T>;
}

type UseGetServicesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetServicesResponseType>,
    References.GetServicesRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getServices', References.GetServicesResponseType>
    : References.GetServicesResponseType;
};

export function useGetServicesSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetServicesResponseType>,
    References.GetServicesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetServicesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SERVICES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getServices: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetServicesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetServicesSuspenseQueryReturn<T>;
}

type UseGetServiceByIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetServiceByIdResponseType>,
    References.GetServiceByIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getServiceById', References.GetServiceByIdResponseType>
        : References.GetServiceByIdResponseType)
    | undefined;
};

export function useGetServiceByIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetServiceByIdResponseType>,
    References.GetServiceByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetServiceByIdQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_SERVICE_BY_ID_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getServiceById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetServiceByIdQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetServiceByIdQueryReturn<T>;
}

type UseGetServiceByIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetServiceByIdResponseType>,
    References.GetServiceByIdRequestType,
    T extends true
      ? Record<'getServiceById', References.GetServiceByIdResponseType>
      : References.GetServiceByIdResponseType
  >;

export function useGetServiceByIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetServiceByIdResponseType>,
    References.GetServiceByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetServiceByIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SERVICE_BY_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getServiceById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetServiceByIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetServiceByIdLazyQueryReturn<T>;
}

type UseGetServiceByIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetServiceByIdResponseType>,
    References.GetServiceByIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getServiceById', References.GetServiceByIdResponseType>
    : References.GetServiceByIdResponseType;
};

export function useGetServiceByIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetServiceByIdResponseType>,
    References.GetServiceByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetServiceByIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SERVICE_BY_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getServiceById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetServiceByIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetServiceByIdSuspenseQueryReturn<T>;
}

type UseGetServicesPagedQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetServicesPagedResponseType>,
    References.GetServicesPagedRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getServicesPaged', References.GetServicesPagedResponseType>
        : References.GetServicesPagedResponseType)
    | undefined;
};

export function useGetServicesPagedQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetServicesPagedResponseType>,
    References.GetServicesPagedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetServicesPagedQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_SERVICES_PAGED_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getServicesPaged: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetServicesPagedQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetServicesPagedQueryReturn<T>;
}

type UseGetServicesPagedLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetServicesPagedResponseType>,
    References.GetServicesPagedRequestType,
    T extends true
      ? Record<'getServicesPaged', References.GetServicesPagedResponseType>
      : References.GetServicesPagedResponseType
  >;

export function useGetServicesPagedLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetServicesPagedResponseType>,
    References.GetServicesPagedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetServicesPagedLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SERVICES_PAGED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getServicesPaged: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetServicesPagedLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetServicesPagedLazyQueryReturn<T>;
}

type UseGetServicesPagedSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetServicesPagedResponseType>,
    References.GetServicesPagedRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getServicesPaged', References.GetServicesPagedResponseType>
    : References.GetServicesPagedResponseType;
};

export function useGetServicesPagedSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetServicesPagedResponseType>,
    References.GetServicesPagedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetServicesPagedSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SERVICES_PAGED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getServicesPaged: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetServicesPagedSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetServicesPagedSuspenseQueryReturn<T>;
}

type UseGetServicesByIdsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetServicesByIdsResponseType>,
    References.GetServicesByIdsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getServicesByIds', References.GetServicesByIdsResponseType>
        : References.GetServicesByIdsResponseType)
    | undefined;
};

export function useGetServicesByIdsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetServicesByIdsResponseType>,
    References.GetServicesByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetServicesByIdsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_SERVICES_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getServicesByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetServicesByIdsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetServicesByIdsQueryReturn<T>;
}

type UseGetServicesByIdsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetServicesByIdsResponseType>,
    References.GetServicesByIdsRequestType,
    T extends true
      ? Record<'getServicesByIds', References.GetServicesByIdsResponseType>
      : References.GetServicesByIdsResponseType
  >;

export function useGetServicesByIdsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetServicesByIdsResponseType>,
    References.GetServicesByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetServicesByIdsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SERVICES_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getServicesByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetServicesByIdsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetServicesByIdsLazyQueryReturn<T>;
}

type UseGetServicesByIdsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetServicesByIdsResponseType>,
    References.GetServicesByIdsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getServicesByIds', References.GetServicesByIdsResponseType>
    : References.GetServicesByIdsResponseType;
};

export function useGetServicesByIdsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetServicesByIdsResponseType>,
    References.GetServicesByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetServicesByIdsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SERVICES_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getServicesByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetServicesByIdsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetServicesByIdsSuspenseQueryReturn<T>;
}

type UseCreateServiceMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.CreateServiceResponseType>,
  References.CreateServiceRequestType,
  T extends true
    ? Record<'createService', References.CreateServiceResponseType>
    : References.CreateServiceResponseType
>;

export function useCreateServiceMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CreateServiceResponseType>,
    References.CreateServiceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateServiceMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_SERVICE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            createService: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateServiceMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateServiceMutationReturn<T>;
}

type UseUpdateServiceMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.UpdateServiceResponseType>,
  References.UpdateServiceRequestType,
  T extends true
    ? Record<'updateService', References.UpdateServiceResponseType>
    : References.UpdateServiceResponseType
>;

export function useUpdateServiceMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateServiceResponseType>,
    References.UpdateServiceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateServiceMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_SERVICE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateService: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateServiceMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateServiceMutationReturn<T>;
}
